// extracted by css-extract-rspack-plugin
module.exports =  {"footerHr":"c09a370c3f","footer":"cdaff3476e"};